import {ecoleFrancaiseGreen, fontFamilyRoboto} from '@components/hoc/Theme/Theme.styled';
import styled from 'styled-components';

// Styled components
export const RadioIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 11px;
  width: 100%;
  @media (max-width: 1024px) {
    padding: 0;
    width: 100%;
  }
`;
export const RadioIconOption = styled.label`
  letter-spacing: normal;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  cursor: pointer;
  font-size: 16px !important;
  font-weight: 400 !important;
  width: 100%;
  word-break: break-word;
  margin: 0 auto;
  border: ${(props) =>
    props.$checked ? '1px solid #00D2A4' : '1px solid rgb(240, 240, 240)'};
  ;
  border-radius: 10px;
  font-family: ${fontFamilyRoboto};
  z-index: 2;
  &:hover {
    transition: 0.1s;
    border-color: transparent;
    box-shadow: 0 0 0 2px ${ecoleFrancaiseGreen};
  }

  @media (max-width: 1024px) {
    font-size: 16px !important;
    width: 100%;
  }
`;

export const RadioIconIcon = styled.div`
  width: 32px;
  height: 32px;
  margin: 0.95rem 2rem;

  @media (max-width: 1024px) {
    margin-left: 0.8rem;
    margin-right: 0.8rem;
  }
`;

export const RadioIconRadio = styled.input`
  position: fixed;
  opacity: 0;
  pointer-events: none;
  ${(props) => (props.$iserror ? 'fill:#f11a48' : 'fill:#60bead')};

  &:hover {
    background-color: '#009E7C';
    border: 2px solid #60bead;
  }

  &:checked {
    background-color: #60bead;
    border: 3px solid #60bead;
  }
`;

export const RadioIconSilencedText = styled.span`
  margin-left: 5px;
  font-size: 13px !important;
  color: ${(props) =>
    props.$checked ? '#fff !important' : '#717171 !important'};
`;
